import {
  Card,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  Layout,
  Page
} from '@superops/ui-design-system';
import React from 'react';
import styled from 'styled-components';;

const SkeletonWrapper = styled.div`
  display: flex;
  justify-content: center;
  .no-shadow-card {
    margin: 0 10px;
    box-shadow: none;
    border: 0.1rem solid #f0f0f6;
  }

  .view-loading-parent {
    height: 100vh;
    width: 100%;
    margin: 16px 40px;
  }
`;

const CardLoading = () => {
  return (
    <SkeletonWrapper>
      <div className="view-loading-parent">
        <Page contentHeight='120px' title={<SkeletonDisplayText size="small" />} primaryAction={<SkeletonDisplayText size="small" />} variant="primary">
          <SkeletonBodyText />
        </Page>
      </div>
    </SkeletonWrapper>
  );
};

export default CardLoading;
